<template>
    <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>  
    <div  class="container mt-1">
    <div class="d-flex justify-content-between align-items-center">
        <div class="topTitle">素材管理</div>
        <div class="ml-1 btnAdd" @click="new_group">新建分组</div>
            <!-- <input type="file" ref="folderInput" webkitdirectory multiple style="display: none" @change="uploadFolder(0)">

            <div @click="selectFolder" class="btnAdd">上传文件夹</div>

            <input type="file" ref="filesInput" multiple style="display: none" @change="uploadFolder(1)">
            <div @click="selectFiles" class="ml-2 btnAdd">上传文件</div> -->
       </div>
    <div v-if="groups.length==0" class="title mt-2">暂无</div>    
    
    <div v-else>

       
        <table  class="mt-2">
            <tr class="table_title">
            <th></th>
            <th>名称</th>
           
            <th>账号</th>
            <th>上传日期</th>
            <th>操作</th>
            </tr>

            <tr v-for="(group,index) in groups" :key="index">
                <td>{{ index+1 }}</td>
                <td>
                   
                    <span>{{ group.name }}</span>
                </td>
               
                <td>
                    <div v-for="(name,ni) in group.accounts" :key="ni">{{ name }}</div>
                </td>
                <td>
                    {{ localDatetime(group.createdDate) }}
                </td>
                <td>
                    <div  class="backBtn mr-1" @click="update(group)">修改</div>
                    <router-link :to="`/index/user/files/${group.objectId}`" ><div class="backBtn mt-1">素材管理</div></router-link>
                  
                </td>

            </tr>
        </table>
    </div>

    <PopupWindow v-model:isShow="showPopup">
        <SucaiGroup @add_suc="add_group" :group="selectedGroup"></SucaiGroup>
    </PopupWindow>  
    </div>
  
  
  </template>
  
  <script>
  
  import GridLoader from 'vue-spinner/src/GridLoader.vue'
  import axios from 'axios';
  import PopupWindow from '@/components/PopupWindow.vue';
  import SucaiGroup from '@/components/SucaiGroup.vue';
  import moment from 'moment'
  
  
  export default {
    data(){
      
      return {
        groups:[],
        isLoading:false,
        
        showPopup: false,
        selectedGroup:null,
       
        spinnerColor:"#262626",
        errors:'',
      
   
  
        
      }
      
    },
      computed: {
        localDatetime() {
            return (datetimeString) => {
            let beijingTime = moment(datetimeString).utcOffset('+08:00').format('YYYY-MM-DD HH:mm:ss');
            return beijingTime
            
            }
        }
        },
    components: {
      GridLoader,
      PopupWindow,  
      SucaiGroup
    },
    
     setup(){
      
       var token=localStorage.getItem('sessionToken')
       axios.defaults.headers.common['X-Parse-Session-Token'] = token
  
    },
  
 
  
    mounted(){
      var token=localStorage.getItem('sessionToken');
      this.role=localStorage.getItem('role');
  
       if(token==undefined || token==null ||token=='')
       {
          this.$router.push('index')
          return
       }
       this.get_groups()
    },
    methods:{
        new_group(){
            this.selectedGroup=null;
            this.showPopup=true;
        },
        add_group(group){
            if(this.selectedGroup==null)
            {
                this.groups.push(group)
            }
            else{
                this.selectedGroup['name']=group['name']
                this.selectedGroup['account_ids']=group['account_ids']
                this.selectedGroup['accounts']=group['accounts']
            }
           
            this.showPopup=false;
            this.selectedGroup=null;
        },
        update(group){
            this.selectedGroup=group;
            this.showPopup=true;
        },

       async get_groups(){
            try{
                this.isLoading=true
                const response = await axios.get(this.domain+'xhs/get_sucai_group');
                var data=response.data
                if(data.status=='Suc')
                {
                    var results=data.groups
                    this.groups=results
                }
                else
                {
                    console.error(data)
                }
            }
            catch(error)
            {
                console.error(data)
            }
            finally{
                this.isLoading=false;
            }
        },


    }
  };
  </script>
  <style scoped>

  </style>
  
  
  